import React from 'react';
import VirtualizedSelect from 'react-virtualized-select'
import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css'
import 'react-virtualized-select/styles.css'
//import '../styles.css';

import player_options from '../data/player_list3';

// TODO: add ref to Select, get labels that way

class PlayerSelect extends React.Component {
	propTypes: {
		label: React.PropTypes.string,
	}

  constructor(props) {
    super(props)
    this.state = {}
  }

  handleSelectChange = (selectValue) => {
    this.setState({ selectValue })
    this.props.how(selectValue)
	}

	render () {
		return (
			<div className="section">
        <VirtualizedSelect multi={true} 
          placeholder={this.props.placeholder}
          options={player_options} 
          onChange={ this.handleSelectChange } resetValue={[]}
          value={this.state.selectValue} />
			</div>
		);
	}
}

export default PlayerSelect;



// WEBPACK FOOTER //
// ./src/components/PlayerSelect.js